import React, { useState, useEffect } from "react";
import {
    Layout,
    Row,
    Form,
    Typography,
    Col,
    Input,
    Card,
    Collapse,
    Space,
    Divider
} from "antd";
import "../../../../assets/styles/DatePicker.css";
import CustomButton from "../../../../components/custom/CustomButton";
import { useNavigate } from "react-router-dom";
import { useForm } from "antd/es/form/Form";
import TableCodeDefinition from "./TableCodeDefinition";
import FormAddCodeValue from "./FormAddCodeValue";



const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

const TableLayoutCodeDefinition = ({ formTitle, disabled, setDisabled }) => {
    const [form] = useForm();
    const navigate = useNavigate();
    const [formData, setFormData] = useState(null);
    const [dataSource, setDataSource] = useState([]);
    const [dataList, setDataList] = useState([])
    const [count, setCount] = useState(1);





    const onFinishForm = (values) => {
        console.log(values);
        setFormData(values);
    }

    const handleValuesChange = (changedValues, allValues) => {
        console.log(changedValues);
        console.log(allValues);
        setFormData(allValues)
    }

    function onCancel() {
        navigate("/sya1000", { replace: false });
    }



    const handleAdd = async (formValues) => {
        try {
            formValues = await form.validateFields();

            if (formValues === null) {
                return;
            } else {
                setDisabled(false);
                const newData = {
                    key: count,
                    name: formData.codeValue,
                    desc: formData.desc,
                    position: formData.position,
                    active: 'false',
                    actions: ""
                };
                setDataSource([...dataSource, newData]);
                setCount(count + 1);
            }
        } catch (errorInfo) {
            console.error('Form validation error:', errorInfo);
        }
    };




    return (
        <Form
            layout="vertical"
            style={{ paddingTop: 20 }}
            onFinish={onFinishForm}
            form={form}
            initialValues={formData}
            onValuesChange={handleValuesChange}>
            <Card
                style={{
                    boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                    borderRadius: 20,
                }}

                title={formTitle}
            >
                <Card
                    style={{
                        marginBottom: "3%",
                        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                    }}
                    bordered
                >
                    <Row>
                        <Col span={24}>
                            <Title level={4} style={{ margin: 5 }}>Code Information</Title>
                            <Divider style={{ marginTop: 0, padding: 0 }} />
                            <div>
                                <Form.Item
                                    name="codeName"
                                    label={<Text strong style={{ fontSize: "15px", margin: "5px" }}>Code name</Text>}
                                >
                                    <Input
                                        style={{ width: "30vh" }}
                                        showSearch
                                    />
                                </Form.Item>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <div style={{ marginBottom: "25px" }}>
                                <Title level={4}>Code Value Info</Title>
                                <Divider style={{ marginTop: 10, padding: 0 }} />
                                <FormAddCodeValue formName={"codeFormData"} handleAdd={handleAdd} form={form} formData={formData} />
                                <TableCodeDefinition
                                    disabled={disabled}
                                    setDisabled={setDisabled}
                                    form={form}
                                    formData={formData}
                                    dataSource={dataSource}
                                    setDataSource={setDataSource}
                                />

                            </div>
                        </Col>
                    </Row>
                </Card>
                <Form.Item>
                    <Row>
                        <CustomButton
                            content="Submit"
                            style={{
                                width: "10%",
                                marginLeft: "auto",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                            }}
                            htmlType="submit"
                            backgroundColor="#92428B"
                            colorText="white"
                            hoverBackground="#AD4EA7"
                        />
                        <CustomButton
                            content="Cancel"
                            style={{
                                width: "10%",
                                marginLeft: "1%",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                            }}
                            backgroundColor="#fff"
                            colorText="black"
                            hoverBackground="#F5F5F5"
                            onClick={onCancel}
                        />
                    </Row>
                </Form.Item>
            </Card>
        </Form>
    )
}

export default TableLayoutCodeDefinition;